import { colors } from '@configs/styles/config'
import { ReactNode } from 'react'
import * as React from 'react'

type Props = {
  children?: ReactNode
  color?: string
  width?: string
  height?: string
  rotate?: string
}

const CertificateIcon: React.FunctionComponent<Props> = (props) => {
  const { width, height } = props
  return (
    <svg
      width={width ? width : '100%'}
      height={height ? height : '100%'}
      viewBox="0 0 21 26"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <filter
          x="-11.1%"
          y="-6.0%"
          width="122.2%"
          height="112.1%"
          filterUnits="objectBoundingBox"
          id="filter-1"
        >
          <feGaussianBlur stdDeviation="19" in="SourceGraphic"></feGaussianBlur>
        </filter>
      </defs>
      <g id="УГУ" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="courses" transform="translate(-1296.000000, -1018.000000)">
          <rect
            id="Rectangle"
            fill="#000000"
            opacity="0.045921689"
            filter="url(#filter-1)"
            x="1176"
            y="237"
            width="514"
            height="944"
            rx="1"
          ></rect>
          <rect
            id="Rectangle-Copy-4"
            fill="#FFFFFF"
            x="1215"
            y="183"
            width="520"
            height="973"
            rx="15"
          ></rect>
          <g
            id="quality"
            transform="translate(1296.000000, 1018.000000)"
            fill={colors.uguBrightPurple}
            fillRule="nonzero"
          >
            <path
              d="M8.32361391,20.4470977 C7.35479488,21.3611651 6.01480555,21.5658825 4.82630341,20.9816128 C4.39664479,20.7703539 4.03406572,20.4786651 3.75021534,20.1292926 L2.13190896,23.7837782 C2.05827677,23.9500399 2.14050019,24.075368 2.17923354,24.121505 C2.21796688,24.1675924 2.3267406,24.269629 2.49885645,24.2207664 L3.67697145,23.8859635 C3.81122764,23.8478546 3.94693996,23.8294692 4.08075931,23.8294692 C4.6453051,23.8294692 5.17665089,24.1556989 5.43249483,24.6963094 L5.96456869,25.8204959 C6.04227807,25.9847753 6.18803777,26.0011784 6.24871031,25.9999395 C6.30821793,25.9991466 6.45460862,25.9794232 6.52819227,25.8131615 L9.10230948,20 C8.8194784,20.083106 8.55164556,20.2319239 8.32361391,20.4470977 Z"
              id="Path"
            ></path>
            <path
              d="M18.0727128,23.7837782 L16.4544283,20.1292926 C16.1705817,20.4787146 15.8080076,20.7704035 15.3783548,20.9816128 C14.1898202,21.5658825 12.8498975,21.3611651 11.8810916,20.4470977 C11.653063,20.2319239 11.3852338,20.083106 11.1023095,20 L13.6763919,25.8131615 C13.7500231,25.9794727 13.8964118,25.9991466 13.9558701,25.9999395 C14.0165418,26.0011784 14.1622995,25.9847753 14.2400078,25.8204959 L14.7720745,24.6963094 C15.0278664,24.1556989 15.5592536,23.8294692 16.1237917,23.8294692 C16.2576093,23.8294692 16.3933683,23.8478546 16.5275741,23.8859635 L17.7056732,24.2207664 C17.8777867,24.2696785 17.9866075,24.1676419 18.0252918,24.121505 C18.0641217,24.0753184 18.146344,23.9499903 18.0727128,23.7837782 Z"
              id="Path"
            ></path>
            <path
              d="M19.2281697,10.5823761 C17.845973,9.61678157 17.4170877,7.69959772 18.2517967,6.21774626 C18.7535107,5.32696495 18.4923958,4.44672573 18.0807318,3.91997762 C17.6690179,3.3933823 16.8859228,2.93783151 15.9231771,3.23856123 C14.3216459,3.7390305 12.5848901,2.88588497 11.9697152,1.29611711 C11.5999314,0.34050448 10.7625767,0 10.102327,0 C9.44207722,0 8.60472258,0.34050448 8.23493879,1.29616804 C7.61976391,2.88598682 5.88315778,3.7390305 4.28147681,3.23861216 C3.31863129,2.93793336 2.53568599,3.3933823 2.12392215,3.92002855 C1.71225814,4.44677665 1.45114326,5.32691402 1.95285721,6.21779719 C2.78756626,7.69959772 2.35868095,9.61683249 0.976484234,10.582427 C0.145568867,11.1629551 0.00655052622,12.0715612 0.153405807,12.7283284 C0.300261089,13.3850957 0.812008316,14.1421401 1.80749943,14.2973177 C3.46343998,14.5554207 4.66513748,16.0928345 4.54339036,17.797445 C4.47011247,18.8221669 5.07974658,19.4996109 5.67460531,19.7919375 C6.26951396,20.0842132 7.16871553,20.1481787 7.90828312,19.4508219 C8.52335816,18.870905 9.31299232,18.5808192 10.1022771,18.5808192 C10.8918613,18.5808192 11.6810462,18.8707522 12.2962211,19.4508219 C13.0358885,20.1482297 13.93514,20.0842641 14.5299987,19.7919375 C15.1248575,19.4996618 15.7344417,18.8222178 15.6612137,17.7974959 C15.5394666,16.0928855 16.7411641,14.5554716 18.3971046,14.2973177 C19.3925957,14.1421401 19.9042431,13.3850447 20.0511982,12.7283284 C20.1981034,12.0714593 20.0589853,11.1628532 19.2281697,10.5823761 Z M10.102327,17.1078801 C6.47961385,17.1078801 3.53232519,14.1008884 3.53232519,10.4047902 C3.53232519,6.708692 6.47956393,3.70164937 10.102327,3.70164937 C13.72509,3.70164937 16.6723288,6.70864107 16.6723288,10.4047393 C16.6723288,14.1008375 13.7250401,17.1078801 10.102327,17.1078801 Z"
              id="Shape"
            ></path>
            <path
              d="M10,5.5 C7.24297014,5.5 5,7.74301684 5,10.5 C5,13.2569832 7.24292345,15.5 10,15.5 C12.7570766,15.5 15,13.2569832 15,10.5 C15,7.74301684 12.7570299,5.5 10,5.5 Z M12.7281774,8.90878177 L9.1297688,10.9032181 C9.01556703,10.9665238 8.87852491,11 8.73899897,11 C8.70303756,11 8.66691417,10.9977874 8.63095276,10.9932802 C8.45551941,10.9712768 8.29903869,10.8966622 8.19677006,10.7861948 L7.12041166,9.62325504 C6.91009683,9.3959692 6.98239761,9.08239095 7.28180603,8.92279506 C7.58126844,8.76319918 7.99444665,8.81802313 8.20481548,9.045268 L8.89326585,9.78912003 L11.9466377,8.09678906 C12.2421584,7.93309572 12.6566865,7.98193739 12.872455,8.20623209 C13.0882774,8.43044484 13.0236441,8.74496551 12.7281774,8.90878177 Z"
              id="Shape"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default CertificateIcon
